module.exports = __webpack_public_path__ + "img/carteira-saida.3c0fb973.svg";